import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Group, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  addResourceToResourceGroup(
    request: Boundaries["addResourceToResourceGroup"]["request"],
  ): void;
}

function useAddResourceToResourceGroup(
  group: Identifiable<Group>,
  resource: Identifiable<any>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isAddResourceToResourceGroupRequestPending(group, resource),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isAddResourceToResourceGroupRequestSuccess(group, resource),
    ),
    isRequestFailure: useSelector(() =>
      selector.isAddResourceToResourceGroupRequestFailure(group, resource),
    ),
    addResourceToResourceGroup: core.addResourceToResourceGroup,
  };
}

export { useAddResourceToResourceGroup };
